import { render } from "./AcModal.vue?vue&type=template&id=9d4520d6&ts=true"
import script from "./AcModal.vue?vue&type=script&lang=ts"
export * from "./AcModal.vue?vue&type=script&lang=ts"

import "./AcModal.vue?vue&type=style&index=0&id=9d4520d6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__